var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserGlobalAction, AdviserGlobalFormAction, ResetAdviserProgressionFormAction, } from "../../../../redux/actions/adviser_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { Status } from "../../../../redux/constants/status";
import { getAdviserQuestionnaireProgressWidth } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Global Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserGlobalQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var error = useState("")[0];
    //using selector hook to fetch data from the reducer
    var _a = useSelector(function (state) { return state.rootReducer.AdviserQuestionnaireReducer; }), adviserGlobalData = _a.adviserGlobalData, status = _a.status, adviserGlobalFormData = _a.adviserGlobalFormData, success_adviserGlobal_form = _a.success_adviserGlobal_form;
    useEffect(function () {
        questionnaireTimer.startSection("Adviser Global Expectations");
        // Adviser Progression prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!adviserGlobalData || adviserGlobalData.length === 0) {
            dispatch(AdviserGlobalAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    // Get the viewing_username (the jobseeker being viewed by the adviser)
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var isSecondAttempt = !!(quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.adv_questionnaire_one_complete);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Adviser Global Expectations");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        var submissionData = __assign({}, sanitizedData);
        // Only record Q1 completion time here; Q2 continues to adviser_jobseeker_outcome
        if (!(quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.adv_questionnaire_one_complete)) {
            var timingData = questionnaireTimer.onQuestionnaireComplete();
            console.log("Q1 adviser questionnaire time: ".concat((timingData.totalSeconds / 60).toFixed(2), " minutes"));
            submissionData.completion_time_seconds = Math.round(timingData.totalSeconds);
            questionnaireTimer.clearTimings();
        }
        dispatch(AdviserGlobalFormAction(submissionData, loginData));
    };
    var handleBackBtn = function () {
        dispatch(ResetAdviserProgressionFormAction());
        navigate("/questionnaire/adviserProgression");
    };
    useEffect(function () {
        if (success_adviserGlobal_form) {
            if (quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.adv_questionnaire_one_complete) {
                // The milestone attempt (if enabled and not yet complete) always
                // comes before Questionnaire 3 (formerly Questionnaire 2).
                if ((quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.milestone_questionnaire_ready) &&
                    !(quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.adv_milestone_questionnaire_complete)) {
                    navigate("/questionnaire/adviserProgressionMilestone");
                }
                else {
                    navigate("/questionnaire/adviserJobseekerOutcome");
                }
            }
            else {
                navigate("/questionnaire/transition");
            }
        }
    }, [success_adviserGlobal_form, quesAttemptDetails, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Adviser - Global Expectations", content: "", data: adviserGlobalData, responses: adviserGlobalFormData, loading: status === Status.Loading, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "global-w", width: getAdviserQuestionnaireProgressWidth("adviserGlobal", isSecondAttempt) })] })));
}
export default AdviserGlobalQuestionnaire;
